import React, {FC} from "react"

import ExpandingListItem from "./ExpandingListItem"
import ListItemShape from "./types/ExpandingListItem"

interface Props {
  items: ListItemShape[]
}

const ExpandingList: FC<Props> = ({items}) => (
  <div>
    {items.map((item, i) => (
      <ExpandingListItem item={item} key={i} />
    ))}
  </div>
)

ExpandingList.defaultProps = {
  items: []
}

export default ExpandingList
